import {
    BenchmarkingDisplay,
    BenchmarkingRequestParams,
    CustomReportFiltersParams,
} from '@/hooks'
import { getTimelineValue } from '@/components/common/Filter/TimelineFilter/utils'

export const processBenchmarkingFilters = (
    filters: CustomReportFiltersParams
): BenchmarkingRequestParams => {
    const { startDate, endDate } =
        'startDate' in filters && 'endDate' in filters
            ? { startDate: filters.startDate, endDate: filters.endDate }
            : getTimelineValue(filters.timeline)

    return {
        'nodeIds[]': filters.nodeIds.join(','),
        commodityTypeId:
            filters.commodityTypeIds?.join(',') ??
            filters.commodityTypeId?.toString(),
        startDate,
        endDate,
        'providerIds[]': filters.providerIds?.join(','),
        'contractIds[]': filters.contractIds?.join(','),
        'panIds[]': filters.panIds?.join(','),
        'tagIds[]': filters.tagIds?.join(','),
        'facilityIds[]': filters.facilityIds?.join(','),
        'usnAccountIds[]': filters.usnAccountIds?.join(','),
        'meterIds[]': filters.meterIds?.join(','),
        unitOfMeasureId: filters.unitOfMeasureId?.toString(),

        type: filters.type as BenchmarkingDisplay,
        trendType: filters.trendType,
        comparisonPeriod: filters.comparisonPeriod,
        applyWeatherNormalization: filters.applyWeatherNormalization,
        applySquareFootage: filters.applySquareFootage,
        includeEmissions: filters.includeEmissions,
    }
}
